export interface IProduct {
  value: string | null;
  description: string;
  count?: number;
}

export type CartProps = {
  additionals?: IProduct[];
  removes?: string[];
  removeAddons?: boolean;
};

export const calcTot = (data: IProduct[]) => {
  return data.reduce((acc, cV) => Number(cV.value) + acc, 0);
};

export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export function mergeWithPriority(additionals: any, ...arrays: any[]) {
  const result: any[] = [];
  const priorityItems: { [description: string]: any } = {};

  if (additionals) {
    for (const item of additionals) {
      priorityItems[item.description] = item;
    }
  }

  for (const array of arrays) {
    if (Array.isArray(array)) {
      for (const item of array) {
        if (item.description in priorityItems) {
          result.push(priorityItems[item.description]);
          // Remover o item de priorityItems para que não seja usado novamente
          delete priorityItems[item.description];
        } else {
          result.push(item);
        }
      }
    }
  }

  result.push(...Object.values(priorityItems));

  return result;
}
